import React, { useEffect } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';


import './App.scss';
import { useAppSelector } from 'segments/hooks';

import ProtectedRoute from 'shared/ProtectedRoute/ProtectedRoute';

import { selectIsAuthenticated } from 'features/auth';
import { useGetWorkTimeMutation } from 'features/config';
import { selectUserRole, useAccountQuery } from 'features/user';

import Dashboard from 'pages/Dashboard/Dashboard';
import SignIn from 'pages/SignIn/SignIn';

// const isAccountLoading = false;
// const isAuthenticated = true;

const App: React.FC = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const role = useAppSelector(selectUserRole);
  const isAllowed = (role === 'admin' || role === 'organization' || role === 'coach') && isAuthenticated;
  const { isLoading: isAccountLoading } = useAccountQuery();
  const [getWorkTime, { isLoading: isWorkTimeLoading }] = useGetWorkTimeMutation();
  useEffect(() => {
    if (isAuthenticated) {
      getWorkTime();
    }
  }, [getWorkTime, isAuthenticated]);

  return (
    <div className="app">
      <Routes>
        <Route path="login" element={<SignIn isAdmin={isAllowed} />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/dashboard/*"
          element={(
            <ProtectedRoute isAccountLoading={isAccountLoading || isWorkTimeLoading} isAuthenticated={isAuthenticated}>
              <Dashboard />
            </ProtectedRoute>
          )}
        />
        <Route path="*" element={<h1>Not founded</h1>} />
      </Routes>
    </div>
  );
};

export default App;
